import gql from 'graphql-tag';

const PERMANENT_DELETE_CUSTOMERS = gql`
  mutation permanentlyDeleteCustomers($customer_ids: [Int!]!) {
    permanentlyDeleteCustomers(customer_ids: $customer_ids) {
      message
      code
    }
  }
`;

export { PERMANENT_DELETE_CUSTOMERS };